import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTowStepLogin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#26C6DA' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M23.682 16.34c0 3.668-2.662 7.103-6.3 8.108a1.47 1.47 0 0 1-.765 0c-3.637-1.005-6.3-4.44-6.3-8.108v-3.292c0-.615.465-1.313 1.043-1.545l4.177-1.71a3.9 3.9 0 0 1 2.933 0l4.177 1.71c.57.232 1.043.93 1.043 1.545z'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M17 17.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17 17.375v2.25'
    />
  </svg>
);
export default SvgTowStepLogin;
